// frontend/src/LoginPage.js

import React, { useState } from 'react';
import './LoginPage.css'; // We'll create this file next

const GITHUB_CLIENT_ID = process.env.REACT_APP_GITHUB_CLIENT_ID;
const GITHUB_AUTH_URL = `https://github.com/login/oauth/authorize?client_id=${GITHUB_CLIENT_ID}&scope=read:user`;
function LoginPage() {
    return (
      <div className="login-container">
        <div className="login-box">
          <h2>Sign In</h2>
          <p>Use your GitHub account to continue.</p>
          <a href={GITHUB_AUTH_URL} className="login-button">
            Login with GitHub
          </a>
        </div>
      </div>
    );
  }
  
  export default LoginPage;